import { FormattedMessage } from 'react-intl';

export const benefits = [
  {
    number: 1,
    title: <FormattedMessage defaultMessage="Быстро" />,
    subtitle: (
      <FormattedMessage defaultMessage="Микрокредит за 10 минут без справок, поручителей и лишних вопросов" />
    ),
  },
  {
    number: 2,
    title: <FormattedMessage defaultMessage="Удобно" />,
    subtitle: (
      <FormattedMessage defaultMessage="Вы узнаете об одобрении микрокредита и получите средства без посещения офиса" />
    ),
  },
  {
    number: 3,
    title: <FormattedMessage defaultMessage="Выгодно" />,
    subtitle: (
      <FormattedMessage defaultMessage="Первые 7 дней вы пользуетесь денежными средствами без начисления процентов" />
    ),
  },
];
